var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHighlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26559 20.2906H18.7344C21.0858 20.2906 23 18.4014 23 16.0807V8.91823C23 6.59756 21.0858 4.70831 18.7344 4.70831L5.26559 4.70937C2.91423 4.70937 1 6.59854 1 8.91929V16.0817C1 18.4024 2.91415 20.2916 5.26559 20.2916V20.2906ZM1.82496 8.9185C1.82496 7.04629 3.36747 5.52278 5.26559 5.52278H18.7344C20.6314 5.52278 22.175 7.04515 22.175 8.9185V16.0809C22.175 17.9531 20.6325 19.4767 18.7344 19.4767H5.26559C3.36862 19.4767 1.82496 17.9543 1.82496 16.0809V8.9185Z",
    fill: "#BF1E2E",
    stroke: "#BF1E2E",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72237 15.8207C9.94993 15.9419 10.196 16.0001 10.4434 16.0001C10.6908 16.0001 10.9382 15.9407 11.1645 15.8207L15.2789 13.6452C15.7288 13.4065 16 12.9786 16 12.4999C16 12.0224 15.7288 11.5934 15.2789 11.3546L11.1645 9.17913C10.7146 8.94037 10.1722 8.94037 9.72105 9.17913C9.27123 9.41789 9 9.8457 9 10.3244V14.6777C9 15.1553 9.27122 15.5843 9.72105 15.823L9.72237 15.8207ZM10.0174 10.3219C10.0174 10.1171 10.1669 10.0177 10.2304 9.98377C10.2675 9.96195 10.3495 9.93044 10.4474 9.93044C10.5122 9.93044 10.5823 9.94256 10.6578 9.98377L14.7722 12.1592C14.9654 12.261 14.9852 12.4295 14.9852 12.4974C14.9852 12.5652 14.9654 12.7337 14.7722 12.8355L10.6578 15.011C10.4646 15.1128 10.2952 15.0449 10.2304 15.011C10.1656 14.977 10.0174 14.874 10.0174 14.6728V10.3195L10.0174 10.3219Z",
    fill: "#BF1E2E",
    stroke: "#BF1E2E",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighlights);
export default __webpack_public_path__ + "static/media/iconHighlights.d586e216498f2ee283529a90b74030c0.svg";
export { ForwardRef as ReactComponent };